import React, { useEffect, useState } from "react";
import WebsiteTestimonials from "../../common/websitetestimonials";
import Inquiry from "../../common/inquiry";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GetMGPanels } from "../../services/website.services";
import Skeleton from "react-loading-skeleton";
import { getLocalKey } from "../../../../utils/commonfunction";

function WebsiteManualGuide() {
  const { t } = useTranslation();
  const Navigate = useNavigate();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [panels, setPanels] = useState([]);


  useEffect(()=>{
    setDataLoaded(false);
    GetMGPanels().then((response)=>{
      if (response.success) {
        setPanels(response.data);
      }
    }).catch((err)=>{
      console.error(err);
    }).finally(()=>{setDataLoaded(true)});
  },[getLocalKey("system_language")]);

  return (
    <div className="manual-guide-page">
      <section className="how-work-sec manual-guide-sec section-padding">
        <div className="container">
          <div className="headings  mb-5 text-center">
            <h4>{t("web_manual_guide")}</h4>
            <h2>{t("web_manual_guide_heading_text")}</h2>
          </div>
          <div className="row how-box">
            {
              dataLoaded?
                <>
                  {panels.map((item, index) => {
                    return (
                      <div
                        className="col-md-3 cp"
                        onClick={() => {
                          Navigate(`/manual-guide-details/${item.slug}/${item?.first_module?.slug}?i=0`);
                        }}
                        key={index}
                      >
                        <article>
                          <figure>
                            <span>
                              <img src={item.icon} alt={item.title} />
                            </span>
                          </figure>
                          <figcaption>
                            <h4>{t(item.title)}</h4>
                            <p>{t(item.description)} </p>
                          </figcaption>
                        </article>
                      </div>
                    );
                  })}
                </>
                :
              <Skeleton className={"d-block rounded-4 mx-3"} height={300} count={4} />
            }
            
          </div>
        </div>
      </section>

      <section className="testimonial-section section-padding pt-0">
        <WebsiteTestimonials id="testimonial-2" />
      </section>
      <Inquiry id="inquiry-2" />
    </div>
  );
}

export default WebsiteManualGuide;
